import axios from '@/utils/api'

const actions = {
  async findByFilter ({ commit }, filter) {
    return axios({
      url: `vistoria/filter`,
      method: 'POST',
      data: filter
    })
  },

  async trocarResponsavel ({ commit }, { idVistoria, idUsuario }) {
    return axios({
      method: 'PUT',
      url: `vistoria/alterarResponsavel/${idVistoria}`,
      data: idUsuario
    })
  },

  async getLaudosViewByVistoriaId ({ commit }, idVistoria) {
    return axios({
      method: 'GET',
      url: `vistoria/laudos/vistoria/${idVistoria}`
    })
  },
  async getLaudosViewByProcessoId ({ commit }, idProcesso) {
    return axios({
      method: 'GET',
      url: `vistoria/laudos/processo/${idProcesso}`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/vistoria/vistoria.js